module.exports = __webpack_public_path__ + "static/img/ic_childcenter@2x.176b540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_childcenter@2x.png
// module id = WQkW
// module chunks = 1